import { render, staticRenderFns } from "./WaybillsReport.vue?vue&type=template&id=6d650caa&scoped=true"
import script from "./WaybillsReport.vue?vue&type=script&lang=js"
export * from "./WaybillsReport.vue?vue&type=script&lang=js"
import style0 from "./WaybillsReport.vue?vue&type=style&index=0&id=6d650caa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d650caa",
  null
  
)

export default component.exports